window.getChatInputMessage = function (selector = "#rd-input-text") {
    const inputElement = $(selector)[0];

    if (!inputElement) {
        return "";
    }

    return inputElement.innerText || inputElement.textContent || "";
};

window.hasChatInputMessage = function (selector = "#rd-input-text") {
    const message = window.getChatInputMessage(selector);

    return message
        .replace(/[\u200B-\u200D\uFEFF]/g, "")
        .replace(/\u00A0/g, " ")
        .trim().length > 0;
};

window.showPadSuggestionPart = function (
    selector = "#rd-pad-suggestion-part",
) {
    const suggestionPart = $(selector);

    if (!suggestionPart.length) {
        return;
    }

    suggestionPart.removeAttr("hidden");
};

$(function () {
    const suggestionPart = $("#rd-pad-suggestion-part");
    const suggestionTitle = suggestionPart.find(".titshow");

    if (!suggestionPart.length) {
        return;
    }

    suggestionTitle.on("click", function (event) {
        event.stopPropagation();

        suggestionPart.toggleClass("do");
    });

    $(document).on("click", function (event) {
        if ($(event.target).closest("#rd-pad-suggestion-part").length) {
            return;
        }

        suggestionPart.removeClass("do");
    });
});

